import { css } from 'styled-components';
import { withUnit } from '../core/withUnit.js';

const height = css `
  height: ${props => withUnit(props.$height)};
`;

export { height };
//# sourceMappingURL=height.js.map
